import * as angular from 'angular';
import template from './resetByQuestion.tpl.html';
import ResetPasswordServiceName, {ResetPasswordService} from "../../services/resetPassword/resetPassword.service";
import NotifyServiceName, {NotifyService} from "../../services/notify/notify.service";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";

let requires = [ResetPasswordServiceName, NotifyServiceName, LoaderServiceName];

export function openResetByQuestion(userName: string,
                                    options: apsViewModels.PasswordResetOptions,
                                    $modal: mm.foundation.modal): angular.IPromise<any> {
  return $modal.open({
    template: template,
    controller: 'ResetByQuestionCtrl as vm',
    resolve: {
      userName: () => userName,
      options: () => options
    }
  }).result;
}

class ResetByQuestion {
  private instance: mm.foundation.modalInstance;
  private resetPasswordService: ResetPasswordService;
  private notifyService: NotifyService;
  private loaderService: LoaderService;

  command: any;
  question: string;
  form: angular.IFormController;

  constructor($modalInstance: mm.foundation.modalInstance,
              resetPasswordService: ResetPasswordService,
              notifyService: NotifyService,
              loaderService: LoaderService,
              userName: string,
              options: apsViewModels.PasswordResetOptions) {

    this.instance = $modalInstance;
    this.resetPasswordService = resetPasswordService;
    this.notifyService = notifyService;
    this.loaderService = loaderService;

    this.command = {
      userName: userName
    };
    this.question = options.securityQuestionText;
  }

  changePassword() {
    if (this.form.$invalid) {
      return;
    }

    let promise = this.resetPasswordService
      .submitQuestionPasswordReset(this.command)
      .then(() => {
        this.notifyService.success('Password changed. You may now sign in!');
        this.instance.close();
      }, this.notifyService.handleApiErrors);

    this.loaderService.loadingPromise(promise);
  }

  close() {
    this.instance.close();
  }
}

export default angular.module('aps.controller.resetByQuestion', requires)
  .controller('ResetByQuestionCtrl', ResetByQuestion)
  .name;



// WEBPACK FOOTER //
// ./src/app/controllers/signIn/resetByQuestion.ts